/**
 * Interview in een overlay
 */

const VerhaalDialog = () => {
  // main.js draait als kale IIFE in een async script in de <head>, dus of de
  // DOM al staat verschilt per pageload. Zonder deze wacht vindt de query soms
  // nul kaarten en stopt de module meteen. Bij klikken valt dat niet op (dan is
  // er een volgende pageload), bij een gedeelde link wel: die krijgt maar een
  // kans. Dit is de oorzaak van "werkt bij mij wel, bij jou niet".
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', VerhaalDialog, { once: true })
    return
  }

  const kaarten = [].slice.call(document.querySelectorAll('.js-verhaal-kaart'))
  if (!kaarten.length) return

  // Per anker de openfunctie, zodat een gedeelde link het juiste verhaal kan
  // openen. Het anker is dat van de kaart (#stendert-kroon): dat staat al in de
  // pagina sinds de offerte-eis om per interview te kunnen linken.
  const register = {}

  kaarten.forEach(kaart => {
    const dialog = document.getElementById(kaart.dataset.verhaal)
    if (!dialog) return

    // De losse card-with-quote blokken dragen hun anker op een target-blok
    // ervoor, niet op de kaart zelf; dan valt het terug op het dialog-id.
    const slug = kaart.id || dialog.id

    // Twee bronnen: het interview-cards blok heeft een eigen knop, de losse
    // card-with-quote blokken hergebruiken de uitklap-knop uit de shortcode.
    const eigenKnop = kaart.querySelector('.js-verhaal-open')
    const collapseKnop = kaart.querySelector('[data-readmore-control]')
    const trigger = eigenKnop || collapseKnop

    // HandyCollapse (ExpandableText) heeft zijn listener al op de shortcode-knop
    // gezet en luistert op hetzelfde element, dus stopPropagation houdt hem niet
    // tegen: een klik zou zowel de overlay als het inline paneel openen. Het
    // paneel is in de overlay overbodig, dus we halen het uit de DOM.
    const paneel = collapseKnop && document.getElementById(collapseKnop.dataset.readmoreControl)
    if (paneel) paneel.remove()

    const open = () => {
      // LazyLoad.js observeert bij pageload; een img in een gesloten dialog is
      // display:none, waardoor de IntersectionObserver nooit vuurt, ook niet na
      // showModal(). Daarom hier zelf de src zetten.
      dialog.querySelectorAll('img[data-src]').forEach(img => {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset
        img.src = img.dataset.src
        img.removeAttribute('data-src')
      })

      dialog.showModal()
      dialog.querySelector('.c-verhaal-dialog__in').scrollTop = 0

      // position:fixed en niet alleen overflow:hidden, want iOS Safari negeert
      // dat laatste. De scrollpositie bewaren, anders springt de pagina omhoog.
      const y = window.scrollY
      document.body.dataset.verhaalScroll = String(y)
      document.body.style.position = 'fixed'
      document.body.style.top = `-${y}px`
      document.body.style.left = '0'
      document.body.style.right = '0'

      // De slug in de adresbalk, zodat de bezoeker de URL kan kopieren en delen.
      // Pad en query meegeven: een kale '#slug' maakt van /werken-bij/ ineens /,
      // en dan wijst de gedeelde link naar de homepage.
      if (window.history && history.replaceState) {
        history.replaceState(
          null,
          '',
          `${window.location.pathname}${window.location.search}#${slug}`
        )
      }
    }

    const sluit = () => {
      dialog.close()

      const y = parseInt(document.body.dataset.verhaalScroll || '0', 10)
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.left = ''
      document.body.style.right = ''
      window.scrollTo(0, y)

      // Hash weghalen, anders staat de overlay dicht terwijl de URL hem nog
      // aankondigt en bij verversen opnieuw opent.
      if (window.history && history.replaceState && window.location.hash) {
        history.replaceState(
          null,
          '',
          `${window.location.pathname}${window.location.search}`
        )
      }
    }

    register[slug] = open

    if (trigger) {
      trigger.addEventListener('click', e => {
        e.preventDefault()
        e.stopPropagation()
        open()
      })
    }

    // Bij het kaartgrid opent de hele kaart het verhaal. Een echte link erbinnen
    // of tekst die je aan het selecteren bent telt niet als kaart-klik.
    if (eigenKnop) {
      kaart.addEventListener('click', e => {
        if (e.target.closest('a')) return
        if (window.getSelection && String(window.getSelection()).length > 0) return
        open()
      })
    }

    dialog.querySelector('.js-verhaal-sluit').addEventListener('click', () => sluit())

    // Het close-event van <dialog> vuurt niet betrouwbaar in Chrome, dus elke
    // sluitroute herstelt de scroll zelf.
    dialog.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        e.preventDefault()
        sluit()
      }
    })

    dialog.addEventListener('click', e => {
      const r = dialog.getBoundingClientRect()
      const buiten = e.clientX < r.left || e.clientX > r.right ||
                     e.clientY < r.top || e.clientY > r.bottom
      if (buiten) sluit()
    })
  })

  // Zowel #stendert-kroon (de kaart) als #verhaal-stendert-kroon (de dialog)
  // wijzen naar hetzelfde interview; allebei laten werken kost een regel.
  const naam = (window.location.hash || '').replace(/^#/, '')
  const slug = register[naam] ? naam : naam.replace(/^verhaal-/, '')

  if (register[slug]) {
    // setTimeout en geen requestAnimationFrame: die laatste vuurt niet zolang
    // het tabblad onzichtbaar is, en een link uit een bericht of mail wordt
    // vaak juist in een achtergrondtab geopend. De vertraging geeft de browser
    // de tijd om naar het anker te springen, zodat open() de scrollpositie van
    // de kaart vastlegt in plaats van 0.
    setTimeout(register[slug], 50)
  }
}

export default VerhaalDialog
